export default __webpack_public_path__ + "images/56c59388fa8944fdeb86fb51a5ec0ac4-religious_music.webp";